import { useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../../../lib/api";
import { Warning } from "@phosphor-icons/react";

export const DangerZone = () => {
  const [busy, setBusy] = useState(false);

  const purge = async () => {
    if (!window.confirm("This permanently deletes ALL employees (except Super Admin), attendance, leave, payroll, payslips, loans, FnF and announcements. Settings (departments, shifts, policies, holidays) and company documents are kept. Continue?")) return;
    setBusy(true);
    try {
      const r = await api.post("/settings/purge-demo-data");
      toast.success(r.data.message);
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };

  return (
    <section className="bg-white border border-red-200 rounded-lg p-6 space-y-3">
      <h3 className="font-heading font-bold flex items-center gap-2 text-red-700"><Warning size={20} weight="duotone" /> Danger zone</h3>
      <p className="text-sm text-stone-500">Remove all demo/test data and start fresh. Keeps only Super Admin accounts, departments, shifts, leave policies, holidays and company documents.</p>
      <button onClick={purge} disabled={busy} data-testid="purge-demo-data-button"
        className="tap-scale px-6 py-3 rounded-full bg-red-600 text-white text-sm font-bold hover:bg-red-700 transition-colors duration-200 disabled:opacity-60">
        {busy ? "Removing…" : "Remove all employee & test data"}
      </button>
    </section>
  );
};
